import ImageWithErrorHandling from "../components/Shared/ImageWithErrorHandling/imageWithErrorHandling.component";

export const renderErrorViewerPdf = () => (
    <div className="flex flex-column mt-4">

        {
            (!navigator.onLine)
            ?
            <div className='mb-3 flex align-content-center justify-content-center'>
                <ImageWithErrorHandling src="./offline_globe.svg" alt=""
                     classes="img-offline-globe-empty-result"/>
            </div>
            :
            <></>
        }

        <div className="flex align-items-center justify-content-center font-semibold">
            Impossibile visualizzare i termini di utilizzo.
        </div>

        {
            navigator.onLine
            ?
            <></>
            :
            <div className="flex align-items-center justify-content-center mt-3">
                Verifica la connessione di rete e riprova.
            </div>
        }
    </div>
)